var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auditoria-informe-main"}},[_c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('v-card-text',{staticClass:"pa-0"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }